export var cilViewStream = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,64V448H496V64ZM464,96V240H48V96ZM48,416V272H464V416Z' class='ci-primary'/>"];
